import { FeatureFlags } from '../../../common/src/FeatureFlags';

export function hasFeatureFlag(flag: FeatureFlags) {
    return (window as any).zxySettings.featureFlags.includes(flag) as boolean;
}
